
export default {
    name: 'FolderPathPart',
    props: {
        part: {
            type: Object,
            required: true
        },
        arrow: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            over: false
        }
    },
    methods: {
        overDrag (e) {
            this.over = true
            e.dataTransfer.dropEffect = !this.disabled ? 'move' : 'none'
        },
        drop (e) {
            this.over = false
            if (this.disabled) {
                return
            }
            this.$emit('move', this.part)
        }
    }
}
